export const BRAND_KEY_AFH_HUB = "afhhub";
export const BRAND_KEY_ONE_HUB_FOR_CARE = "onehubforcare";

export const SUPPORTED_BRAND_KEYS = [
  BRAND_KEY_AFH_HUB,
  BRAND_KEY_ONE_HUB_FOR_CARE,
] as const;

export type SupportedBrandKey = (typeof SUPPORTED_BRAND_KEYS)[number];
